import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    adminTool: { display: 'flex', flexDirection: 'column' },
    adminToolHeader: {
      fontSize: '20px',
      color: accentColor,
      marginBottom: '16px',
    },
    adminToolBlock: {
      padding: '12px 18px',
      borderRadius: '4px',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#eee',
    },
    blockHeader: {
      fontSize: '16px',
      marginBottom: '8px',
      color: '#3B3B3B',
      display: 'flex',
      alignItems: 'center',
    },
    blockInfo: { color: '#3B3B3B', marginBottom: '16px' },
    blockButtons: { display: 'flex', width: 250, alignSelf: 'center' },
    button: {
      margin: '10px auto',
      width: '200px',
      borderRadius: '4px',
      letterSpacing: '0.8px',
      filter: 'brightness(1)',
      textTransform: 'capitalize',
      transition: 'filter .3s',
      '&:not(:last-child)': {
        marginRight: '10px',
      },
    },
    activeButton: {
      '&:hover': {
        backgroundColor: accentColor,
        filter: 'brightness(1.3)',
      },
      '&:disabled': {
        color: theme.colors.white,
        backgroundColor: accentColor,
        opacity: 0.3,
      },
      backgroundColor: accentColor,
      color: theme.colors.white,
    },
    approveDeclineInfo: {
      marginTop: 20,
    },
    checkbox: {
      marginTop: '10px',
      '& *': { color: 'black !important' },
    },
    disabled: {
      opacity: 0.4,
    },
  }
}
